import { Avatar, Box, Card, Typography } from '@mui/material';
import React from 'react';

export default function Achievement({ title, children }: { title: string }) {
  return (
    <Card sx={{ p: 2, mb: 2 }}>
      {title && (
        <Typography variant="h5" sx={{ mb: 1, mt: 0 }}>
          {title}
        </Typography>
      )}

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '1.5rem',
          '& > *': { mb: 0 },
        }}
      >
        <Avatar
          src="/images/fractalachievement.png"
          sx={{
            width: 64,
            height: 64,
            display: 'inline-flex',
          }}
        />
        {children}
      </Box>
    </Card>
  );
}
